import { render, staticRenderFns } from "./CreateNewMainContract.vue?vue&type=template&id=fcc45326&scoped=true"
import script from "./CreateNewMainContract.vue?vue&type=script&lang=js"
export * from "./CreateNewMainContract.vue?vue&type=script&lang=js"
import style0 from "./CreateNewMainContract.vue?vue&type=style&index=0&id=fcc45326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc45326",
  null
  
)

export default component.exports